import React from 'react'

const Contact = () => {

    return (
        <div id='Contact_box' className='d-flex flex-column justify-content-center'>
            <div className='contact_center d-flex flex-column justify-content-center'>
                <span className='contact_logo'><i class="fa fa-phone" aria-hidden="true">   Contact Me</i></span>
                <span className='number'>+91 7238007782</span>
            </div>
        </div>
    )
}

export default Contact;